<section class='home-componente'>
  <Div class="home"></Div>
  <div class="container bannerWrapper">
    <div class="banner">
      <h3 >Ippo Tecnologia</h3>
      <p >Desenvolvimento de softwares</p>
      <button class="btn btn-dark btn-md" [routerLink]="['/contato']">Contate-nos</button>
    </div>
  </div>
</section>
